import { FC } from 'react';

import { Stack, Typography } from '@mui/material';
import { useAppSelector } from 'hooks';
import { IconInfoFilled } from 'icons';
import { NeutralColors } from 'portfolio3/styles';
import { configSelector } from 'selectors';
import { SxStyles } from 'types';

const VuzRecommendationWidgetListInfoBlock: FC = () => {
  const config = useAppSelector(configSelector);
  const year = config?.YEAR_DATA_PRESENTED;
  const stackStyles: SxStyles = {
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',

    width: '100%',

    padding: '16px',
    marginBottom: '16px',
    backgroundColor: NeutralColors.light_neutrals_200,
    borderRadius: '8px',
  };
  return (
    <Stack sx={stackStyles}>
      <IconInfoFilled fill={NeutralColors.light_neutrals_600} sx={{ width: '20px' }} />
      <Typography color={NeutralColors.light_neutrals_900} variant="Paragraph MD/Regular">
        Данные представлены за {year} год
      </Typography>
    </Stack>
  );
};

export default VuzRecommendationWidgetListInfoBlock;
